import { GET_ADMIN } from "./types";

export const setAdmin = admin => ({
  type: GET_ADMIN,
  payload: { admin: admin }
});
